import React from "react";
import { useGraphAPIHook } from "../../../portal";
import { ClientContext } from "@limitless/common/utils";
import { useAppConfig } from "@limitless/common/hooks";
const CREATE_MESSAGE = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "mutation",
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "message"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "CreateExpertSupportMessageInput"
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "createExpertSupportMessage"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "message"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "message"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "messageId"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 155,
    "source": {
      "body": "\n    mutation ($message: CreateExpertSupportMessageInput!) {\n        createExpertSupportMessage(message: $message) {\n            messageId\n        }\n    }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
export const useExpertSupportMessageCreation = () => {
  const [isLoading, setLoading] = React.useState(false);
  const [selectedTabIndex, setSelectedTabIndex] = React.useState(0);
  const [showLLMLanding, setShowLLMLanding] = React.useState(false);
  const [isFabVisible, setIsFabVisible] = React.useState(false);
  const [submitMessage, setSubmitMessage] = React.useState(false);
  const [isReceived, setIsReceived] = React.useState(false);
  const [getInTouchScreen, setGetinTouchScreen] = React.useState(false);
  const [announcementMessage, setAnnouncementMessage] = React.useState(false);
  const [queryTopic, setQueryTopic] = React.useState("");
  const [queryDescription, setQueryDescription] = React.useState("");
  const [error, setError] = React.useState(false);
  const [announcementRouteState, setAnnouncementRouteState] = React.useState(null);
  const [hasPressed, setHasPressed] = React.useState(false);
  const [announcementBody, setAnnouncementMessageBody] = React.useState("");
  const {
    mutateData
  } = useGraphAPIHook();
  const {
    getExpertSupportDetails
  } = useAppConfig();
  const {
    privateSupport: {
      groupName
    }
  } = getExpertSupportDetails();
  const clearMessage = () => {
    setQueryDescription("");
    setQueryTopic("");
    setHasPressed(false);
    setShowLLMLanding(false);
    setGetinTouchScreen(false);
  };
  const createMessage = message => {
    const createExpertSupportMessage = {
      mutation: CREATE_MESSAGE,
      variables: {
        message
      },
      responseKey: "createExpertSupportMessage",
      notifyDetails: {
        actionName: "Create Expert support message",
        errorNotification: "Failed to create expert support message"
      },
      postSuccessFunction: () => {
        setSubmitMessage(true);
        clearMessage();
        setGetinTouchScreen(false);
      }
    };
    mutateData(createExpertSupportMessage);
  };
  const handleQueryDetailsChange = event => {
    const value = event.target.value;
    setQueryDescription(value);
    if (value.length < 10) {
      setError(true);
    } else {
      setError(false);
    }
  };
  const handleAnnouncementMessage = event => {
    const value = event.target.value;
    setAnnouncementMessageBody(value);
    if (value.length < 10) {
      setError(true);
    } else {
      setError(false);
    }
  };
  const handleConversationHistory = () => {
    setSelectedTabIndex(1);
    setSubmitMessage(false);
    setIsReceived(false);
    setLoading(false);
    if (announcementRouteState) {
      setAnnouncementRouteState(null);
    }
  };
  const handleSubmitAnnouncementMessage = () => {
    const extraInfo = {
      category: {
        Topic: "Re: Announcement"
      }
    };
    const message = {
      body: `Re: ${announcementRouteState.body}\n${announcementBody}`,
      groupName,
      tenantChannel: "llm",
      tenantMsgSource: ClientContext._tenantMsgSource,
      tenantMsgType: ClientContext._tenantMsgType,
      customerData: JSON.stringify(extraInfo)
    };
    setAnnouncementMessage(true);
    setSelectedTabIndex(0);
    createMessage(message);
  };
  const handleSubmitMessage = () => {
    const extraInfo = {
      category: {
        Topic: queryTopic
      }
    };
    const message = {
      body: queryDescription,
      groupName: queryTopic,
      tenantChannel: "llm",
      tenantMsgSource: ClientContext._tenantMsgSource,
      tenantMsgType: ClientContext._tenantMsgType,
      customerData: JSON.stringify(extraInfo)
    };
    createMessage(message);
  };
  return {
    hasPressed,
    clearMessage,
    handleSubmitMessage,
    setLoading,
    isLoading,
    selectedTabIndex,
    setSelectedTabIndex,
    showLLMLanding,
    setShowLLMLanding,
    announcementBody,
    isFabVisible,
    setIsFabVisible,
    submitMessage,
    setSubmitMessage,
    isReceived,
    getInTouchScreen,
    setGetinTouchScreen,
    setAnnouncementMessage,
    announcementMessage,
    queryTopic,
    setQueryTopic,
    queryDescription,
    setQueryDescription,
    error,
    announcementRouteState,
    setAnnouncementRouteState,
    handleConversationHistory,
    handleSubmitAnnouncementMessage,
    handleQueryDetailsChange,
    handleAnnouncementMessage,
    setIsReceived
  };
};